var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 209 183",
    style: {
      enableBackground: "new 0 0 209 183"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CFCFCF;}\r\n\t.st1{fill:none;stroke:#8EA3B6;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#1F2831;}\r\n\t.st3{fill:#8EA3B6;}\r\n\t.st4{fill:#4F5E6C;}\r\n\t.st5{fill:#3D4854;}\r\n\t.st6{fill:#D4E7F8;stroke:#8EA3B6;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:none;stroke:#8EA3B6;stroke-width:3.6146;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st8{fill:#8EA3B6;stroke:#8EA3B6;}\r\n\t.st9{fill:#4F5E6C;stroke:#4F5E6C;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st10{fill:none;stroke:#8EA3B6;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.5,144.3c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-1,0-1.7,0.8-1.7,1.7 C102.8,143.5,103.5,144.3,104.5,144.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54,13.9v7.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.2,17.7h7.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.8,61.8c-14.8,0-29.9-0.6-44-4.5C82.9,53.5,70.2,46,58.8,37.4C51.4,31.8,44.6,27.3,35,28 c-9.4,0.5-18.4,4-25.7,10C-3,48.7-1.1,68.6,3.8,82.5c7.4,21,29.8,35.6,48.9,45.1c22,11,46.2,17.4,70.5,21c21.3,3.2,48.6,5.6,67-8.3 c16.9-12.7,21.6-41.8,17.4-61.4c-1-5.8-4.1-11-8.7-14.7c-11.9-8.7-29.6-2.9-43-2.6C150.9,61.7,145.8,61.8,140.8,61.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.8,3.5c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-1,0-1.7,0.8-1.7,1.7C115,2.7,115.8,3.5,116.8,3.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,138.4v7.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,142.2h7.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.2,183c35.9,0,65-1.8,65-4.1c0-2.3-29.1-4.1-65-4.1c-35.9,0-65,1.8-65,4.1C40.2,181.2,69.3,183,105.2,183z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M157.5,135.6H45.1c-0.8,0-1.5-0.2-2.2-0.5c-0.7-0.3-1.3-0.8-1.8-1.3c-0.5-0.6-0.8-1.2-1-2 c-0.2-0.7-0.2-1.5-0.1-2.2l14.4-86.9c0.2-1.2,0.8-2.3,1.8-3.1c0.9-0.8,2.1-1.2,3.4-1.2h112.4c0.8,0,1.5,0.2,2.2,0.5 c0.7,0.3,1.3,0.8,1.8,1.3c0.5,0.6,0.8,1.2,1,2c0.2,0.7,0.2,1.5,0.1,2.2l-14.3,86.9c-0.2,1.2-0.8,2.3-1.8,3.1 C159.9,135.2,158.7,135.6,157.5,135.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M158.9,36L92.2,6.3c-2-0.9-4.3,0-5.1,2L65.9,55.5c-0.9,2,0,4.3,2,5.1l66.7,29.7c2,0.9,4.3,0,5.1-2l21.1-47.2 C161.7,39.2,160.8,36.9,158.9,36z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102,45.2c1.8-2.5,4.3-4.2,7.2-5c2.9-0.8,6-0.6,8.8,0.7c2.8,1.2,5,3.4,6.4,6.1c1.4,2.7,1.7,5.8,1.1,8.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M135.2,40.7c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C134.5,39.3,135.2,39.9,135.2,40.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M108.7,28.9c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C108.1,27.6,108.7,28.2,108.7,28.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M157,135.5H44.1c-1.4,0-2.7-0.6-3.7-1.5c-1-1-1.5-2.3-1.5-3.7V50.9c0-0.7,0.1-1.4,0.4-2 c0.3-0.6,0.6-1.2,1.1-1.7c0.5-0.5,1.1-0.9,1.7-1.2c0.6-0.3,1.3-0.4,2-0.4h41.1c1,0,1.9,0.3,2.7,0.8c0.8,0.5,1.5,1.2,1.9,2.1 l5.9,11.4c0.4,0.9,1.1,1.6,1.9,2.1c0.8,0.5,1.7,0.8,2.7,0.8H157c1.4,0,2.7,0.5,3.7,1.5c1,1,1.5,2.3,1.5,3.7v62.5 c0,1.4-0.5,2.7-1.5,3.7C159.7,135,158.4,135.5,157,135.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M139.6,65.4c-6.5,0-12.9,1.9-18.3,5.5c-5.4,3.6-9.7,8.7-12.2,14.8c-2.5,6-3.2,12.6-1.9,19 c1.3,6.4,4.4,12.2,9,16.9c4.6,4.6,10.5,7.7,16.9,9c6.4,1.3,13,0.6,19.1-1.9c6-2.5,11.2-6.7,14.8-12.1c3.6-5.4,5.6-11.8,5.6-18.3 c0-8.7-3.5-17.1-9.7-23.2C156.7,68.9,148.3,65.4,139.6,65.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M163.1,122.2l8.8,8.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.9,126.7l-2.7,2.9c-1.2,1.3-1.2,3.3,0.1,4.5l23.7,22.6c1.3,1.2,3.3,1.2,4.5-0.1l2.7-2.9 c1.2-1.3,1.2-3.3-0.1-4.5l-23.7-22.6C174.1,125.4,172.1,125.4,170.9,126.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.4,1.8v7.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.6,5.6h7.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundDark);
export default __webpack_public_path__ + "static/media/not-found-dark.5f47b81f08530d50ae403e2ecbbebfb9.svg";
export { ForwardRef as ReactComponent };